import { useEffect } from 'react'
import { Stack } from '@machobear/design-system'
import { Form, useFormikContext } from 'formik'

import PaymentFormComponent from '@/components/ds-checkout-modal/payment-form'
import { PaymentFormValuesType } from '@/hooks/use-payment-validation'

type FormProps = {
  setState: React.Dispatch<React.SetStateAction<string | null>>
}

const PaymentForm: React.FC<FormProps> = ({ setState }) => {
  const { values }: { values: PaymentFormValuesType } = useFormikContext()

  const formState = values.state
  useEffect(() => {
    if (formState) {
      setState(formState)
    }
  }, [formState])
  return (
    <Form>
      <Stack space="medium">
        <PaymentFormComponent />
      </Stack>
    </Form>
  )
}

export default PaymentForm
